import React, { useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button';
import Input from '../../components/common/Input';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const userId = params.get('k') || params.get('userId') || '';
  const code = params.get('c') || params.get('code') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (password !== confirm) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { userId, code, newPassword: password });
      toast.success('Password has been reset. Please sign in.');
      navigate('/login');
    } catch (e: any) {
      const msg = e?.response?.data?.message || 'Failed to reset password';
      toast.error(msg);
    } finally { setLoading(false); }
  };

  if (!userId || !code) {
    return (
      <div className="min-h-[40vh] grid place-items-center">
        <div className="text-center">
          <div className="text-gray-700 mb-4">Invalid or missing reset link.</div>
          <Link to="/forgot-password"><Button>Request new link</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md mx-auto">
      <form onSubmit={submit} className="space-y-6">
        <h1 className="text-2xl font-bold text-gray-900 text-center">Reset Password</h1>
        <Input label="New Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <Input label="Confirm Password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        <Button type="submit" loading={loading} className="w-full">Reset Password</Button>
      </form>
    </div>
  );
};

export default ResetPassword;


